export default __webpack_public_path__ + "static/media/withFoodOf.3913d92a.svg";